export default "__VITE_ASSET__8dd46c16__"